import PageShell from '@components/pages/PageShell';
import { ResourceHero } from '@components/pages/ResourceSections';
import JusticePerformance from '@components/landing/JusticePerformance';
import Newsletter from '@components/landing/Newsletter';

export default function CourtRanking() {
    return (
        <PageShell>
            <ResourceHero
                titleLead="High Court"
                titleBold="Ranking"
                intro="How every state high court performs on speed, transparency and case turnaround. Pick a state on the map and a year to compare."
                search={false}
            />
            <JusticePerformance />
            <Newsletter />
        </PageShell>
    );
}
